/* RESPONSIBLE TEAM: team-reporting */
import Time from './time';
import Seconds from './seconds';
import Value from './value';
import ValueSingle from './value-single';
import Percent from './percent';
import Range from './range';

export default class Formatters {
  static minute = Time;
  static seconds = Seconds;
  static value = Value;
  static valueSingle = ValueSingle;
  static percent = Percent;
  static valuePerHour = Value;
  static range = Range;
}

export { units } from '@intercom/reporting-core';
